import * as z from "zod";

// Under `/auth/*`, which already runs the Worker first, beside the
// reader_session renewal that presents the same cookie to the broker.
export const BOOKMARK_TOKEN_PATH = "/auth/reader-bookmark";

export const bookmarkTokenRequestSchema = z
  .object({ reset: z.boolean().optional() })
  .strict();
export type BookmarkTokenRequest = z.infer<typeof bookmarkTokenRequestSchema>;

// `issued` is false when the reader's existing link came back unchanged.
export const bookmarkTokenResponseSchema = z.object({
  url: z.url(),
  issued: z.boolean(),
});
export type BookmarkTokenResponse = z.infer<typeof bookmarkTokenResponseSchema>;

export const bookmarkTokenErrorSchema = z.object({
  error: z.enum([
    "method_not_allowed",
    "cross_site",
    "unserved_host",
    "misconfigured",
    "no_reader",
    "invalid_request",
    "rate_limited",
    "upstream_failed",
  ]),
});
export type BookmarkTokenError = z.infer<typeof bookmarkTokenErrorSchema>;
